import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const SettingsContext = createContext(null);

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function SettingsProvider({ children }) {
    const [settings, setSettings] = useState({
        demo_mode: true,
        featured_banner_text: 'Welcome to Burston Garden Centre',
        cafe_special_text: 'Try our delicious homemade cakes!',
        cafe_opening_times: 'Mon-Sat: 9am-5pm, Sun: 10am-4pm'
    });
    const [seniorMode, setSeniorMode] = useState(() => {
        return localStorage.getItem('burston_senior_mode') === 'true';
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchSettings();
    }, []);

    useEffect(() => {
        // Apply senior mode to HTML element
        if (seniorMode) {
            document.documentElement.classList.add('senior-mode');
        } else {
            document.documentElement.classList.remove('senior-mode');
        }
        localStorage.setItem('burston_senior_mode', seniorMode.toString());
    }, [seniorMode]);

    const fetchSettings = async () => {
        try {
            const response = await axios.get(`${API}/settings`);
            setSettings(response.data);
        } catch (error) {
            console.error('Settings fetch error:', error);
        } finally {
            setLoading(false);
        }
    };

    const toggleSeniorMode = () => {
        setSeniorMode(prev => !prev);
    };

    const value = {
        settings,
        seniorMode,
        toggleSeniorMode,
        loading,
        refreshSettings: fetchSettings,
    };

    return (
        <SettingsContext.Provider value={value}>
            {children}
        </SettingsContext.Provider>
    );
}

export function useSettings() {
    const context = useContext(SettingsContext);
    if (!context) {
        throw new Error('useSettings must be used within a SettingsProvider');
    }
    return context;
}

export default SettingsContext;
